import { socialLinks, chinaLinks } from '../data/socialLinks';
import SocialIcon from './SocialIcon';

export default function FooterSocialLinks() {
  return (
    <div className="social-group" aria-label="Vicinity social media">
      <span className="social-heading">Follow us</span>
      <div className="social-list">
        {[...socialLinks, ...chinaLinks].map(({ name, url, icon }) => (
          <a
            key={name}
            className="social-link"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${name} — opens in a new tab`}
            title={name}
          >
            <SocialIcon name={icon} aria-hidden="true" />
            <span className="social-tooltip">{name}</span>
          </a>
        ))}
      </div>
    </div>
  );
}